import React, { Component } from 'react'
import { Fade } from 'react-reveal'
import classNames from 'classnames'

import Page from '../templates/Page'
import PageSection from '../templates/PageSection'
import ActionButton from '../components/ActionButton'
import { RowLayout } from '../../components/layout'

import './home.css'
import mobileAppOnDevice from '../assets/old-images/home/cell.png'
import appStoreBadge from '../assets/old-images/home/app-store-badge.svg'
import googlePlayBadge from '../assets/old-images/home/google-play-badge.png'

class Home extends Component {
  render() {
    return (
      <Page
        className="home"
        headerTitle="The World&#39;s Audio"
        headerSubtitle="Internet radio programmed by real people, not an algorithm."
        withHeaderBackgroundImage
        header={null}
      >
        <PageSection>
          <div className={classNames('column', 'padded-section-content')}>
            <h1 className="section-heading">
              Create Your Own Internet Radio Station
            </h1>

            <RowLayout
              isResponsive
              itemSpacing={'4vw'}
              style={{ marginBottom: '2vw' }}
            >
              <Fade top duration={700}>
                <div className="section-element">
                  <div className="badge green">
                    <svg
                      width="47"
                      height="36"
                      viewBox="0 0 47 36"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        fillRule="nonzero"
                        fill="#333"
                        stroke="none"
                        strokeWidth="1"
                      >
                        <path
                          d="M0 24.1423173C0 25.7125337.764828613 27.0992684 1.93138539 27.9799801L1.93138539 20.3046546C.764828613 21.1872977 0 22.5701696 0 24.1423173zM37.662015 13.5196977L37.6137304 13.5196977C37.1115702 5.98343193 30.8384305 0 23.1766246 0 15.5148188 0 9.24167908 5.98343193 8.73951888 13.5196977L8.69123424 13.5196977C6.02978518 13.5196977 3.86277077 15.6867121 3.86277077 18.3481612L3.86277077 29.9364735C3.86277077 32.5998539 6.02978518 34.764937 8.69123424 34.764937L12.554005 34.764937C13.0870674 34.764937 13.5196977 34.3323066 13.5196977 33.7992443L13.5196977 14.4853904C13.5196977 13.952328 13.0870674 13.5196977 12.554005 13.5196977L10.6709043 13.5196977C11.1672703 7.04955666 16.5809435 1.93138539 23.1766246 1.93138539 29.7723057 1.93138539 35.185979 7.04955666 35.682345 13.5196977L33.7992443 13.5196977C33.2661819 13.5196977 32.8335516 13.952328 32.8335516 14.4853904L32.8335516 33.7992443C32.8335516 34.3323066 33.2661819 34.764937 33.7992443 34.764937L37.662015 34.764937C40.3234641 34.764937 42.4904785 32.5998539 42.4904785 29.9364735L42.4904785 18.3481612C42.4904785 15.6867121 40.3234641 13.5196977 37.662015 13.5196977zM44.4218639 20.306586L44.4218639 27.9819115C45.5884207 27.1011998 46.3532493 25.714465 46.3532493 24.1442487 46.3532493 22.5701696 45.5884207 21.1872977 44.4218639 20.306586z"
                          transform="translate(0 .794)"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="element-text">
                    <h3 className="element-heading">Audience</h3>
                    <p className="element-description">
                      On mobile, home devices and the web, your station will be
                      in front of a growing audience on the Live365 Radio
                      Network.
                    </p>
                  </div>
                </div>
              </Fade>

              <Fade top duration={700} delay={100}>
                <div className="section-element">
                  <div className="badge blue">
                    <svg
                      width="31"
                      height="41"
                      viewBox="0 0 31 41"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.6684902,7.82598963 C10.3506838,7.95615501 10.1427573,8.26550911 10.1427573,8.60867239 L10.1427573,28.0472667 L5.9166084,28.0472667 C2.65402148,28.0472667 0,30.7012882 0,33.9638751 C0,37.226462 2.65402148,39.8804835 5.9166084,39.8804835 C9.06931545,39.8804835 11.8332168,37.1148917 11.8332168,33.9638751 L11.8332168,15.0915847 L28.7378122,8.17591475 L28.7378122,21.2854285 L24.5116634,21.2854285 C21.2490765,21.2854285 18.595055,23.93945 18.595055,27.2020369 C18.595055,30.4646238 21.2490765,33.1186453 24.5116634,33.1186453 C27.6643704,33.1186453 30.4282718,30.3530535 30.4282718,27.2020369 L30.4282718,0.999913992 C30.4282718,0.401491314 29.8180159,-0.00929035513 29.2618547,0.218921683 L10.6684902,7.82598963 Z"
                        transform="translate(.07 .69)"
                        fillRule="nonzero"
                        fill="#333"
                        stroke="none"
                        strokeWidth="1"
                      />
                    </svg>
                  </div>
                  <div className="element-text">
                    <h3 className="element-heading">Licensing</h3>
                    <p className="element-description">
                      Live365 covers your listeners in the USA (through
                      SoundExchange, ASCAP, BMI, and SESAC), in Canada (through
                      SOCAN and Re:Sound), and in the UK (through PPL and PRS
                      for Music).
                    </p>
                  </div>
                </div>
              </Fade>

              <Fade top duration={700} delay={200}>
                <div className="section-element">
                  <div className="badge yellow">
                    <svg
                      width="26"
                      height="47"
                      viewBox="0 0 24 47"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M60.5314286,38.8708738 L60.5314286,41.3349515 C62.1619129,41.5022662 63.5599942,41.8368907 64.7257143,42.338835 C65.8914344,42.8407792 66.9085671,43.6012894 67.7771429,44.6203883 C68.4628606,45.3961204 68.9923791,46.1946561 69.3657143,47.0160194 C69.7390495,47.8373827 69.9257143,48.5902878 69.9257143,49.2747573 C69.9257143,50.0352789 69.6476218,50.6931202 69.0914286,51.248301 C68.5352353,51.8034817 67.8609563,52.081068 67.0685714,52.081068 C65.5752306,52.081068 64.6076213,51.2749272 64.1657143,49.6626214 C63.6628546,47.7613174 62.4514382,46.4988704 60.5314286,45.8752427 L60.5314286,55.3665049 C62.4209618,55.8836595 63.9257087,56.3551759 65.0457143,56.781068 C66.1657199,57.2069601 67.1676146,57.8229733 68.0514286,58.6291262 C68.9961952,59.4657 69.723807,60.4657709 70.2342857,61.6293689 C70.7447645,62.792967 71,64.0668216 71,65.4509709 C71,67.1849601 70.592385,68.8086494 69.7771429,70.3220874 C68.9619007,71.8355254 67.7619127,73.0713544 66.1771429,74.0296117 C64.592373,74.9878689 62.7104871,75.5582515 60.5314286,75.7407767 L60.5314286,81.4218447 C60.5314286,82.3192602 60.4438104,82.9732989 60.2685714,83.3839806 C60.0933325,83.7946622 59.7085744,84 59.1142857,84 C58.5657115,84 58.1809535,83.8326878 57.96,83.4980583 C57.7390465,83.1634287 57.6285714,82.6462818 57.6285714,81.9466019 L57.6285714,75.7864078 C55.8457054,75.5886722 54.2876257,75.1703915 52.9542857,74.5315534 C51.6209457,73.8927153 50.5085759,73.0979821 49.6171429,72.1473301 C48.7257098,71.1966781 48.0666688,70.2080148 47.64,69.1813107 C47.2133312,68.1546065 47,67.1469305 47,66.1582524 C47,65.4281517 47.2857114,64.7703104 47.8571429,64.1847087 C48.4285743,63.5991071 49.1409481,63.3063107 49.9942857,63.3063107 C50.6800034,63.3063107 51.2590453,63.4660178 51.7314286,63.7854369 C52.2038119,64.104856 52.5314277,64.553557 52.7142857,65.1315534 C53.1257163,66.3788088 53.483808,67.3332491 53.7885714,67.9949029 C54.0933349,68.6565567 54.5542826,69.2611623 55.1714286,69.8087379 C55.7885745,70.3563134 56.6076139,70.774594 57.6285714,71.0635922 L57.6285714,60.4543689 C55.5866565,59.8915829 53.8800069,59.264162 52.5085714,58.5720874 C51.137136,57.8800127 50.0247662,56.895152 49.1714286,55.6174757 C48.318091,54.3397994 47.8914286,52.6970974 47.8914286,50.6893204 C47.8914286,48.0731261 48.7257059,45.9284873 50.3942857,44.2553398 C52.0628655,42.5821923 54.4742699,41.6087392 57.6285714,41.3349515 L57.6285714,38.9165049 C57.6285714,37.6388286 58.1085666,37 59.0685714,37 C60.0438144,37 60.5314286,37.6236184 60.5314286,38.8708738 Z M57,55 L57,47 C55.7415667,47.3481305 54.7603031,47.807656 54.0561798,48.3785901 C53.3520564,48.9495242 53,49.812875 53,50.9686684 C53,52.0687609 53.3295847,52.9007805 53.988764,53.464752 C54.6479434,54.0287234 55.6516787,54.5404677 57,55 Z M61,61 L61,71 C62.5955846,70.6955845 63.8277998,70.0791523 64.6966825,69.1506849 C65.5655652,68.2222176 66,67.1415587 66,65.9086758 C66,64.5844683 65.5774134,63.5608864 64.7322275,62.8378995 C63.8870416,62.1149127 62.6429782,61.5022856 61,61 Z"
                        transform="translate(-47 -37)"
                        fill="#333"
                        stroke="none"
                        strokeWidth="1"
                        fillRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="element-text">
                    <h3 className="element-heading">Monetization</h3>
                    <p className="element-description">
                      Our simple targeted audio ads lower your monthly cost and
                      share revenue back to your station.
                    </p>
                  </div>
                </div>
              </Fade>
            </RowLayout>

            <ActionButton
              title="Learn More"
              route="/broadcaster/overview"
              color="orange"
            />
          </div>
        </PageSection>

        <PageSection
          className={classNames(
            'get-apps',
            'with-bottom-image',
            'with-background-image',
            'light-on-dark'
          )}
        >
          <div className="row">
            <Fade duration={500} fraction={0.5}>
              <div className={classNames('column', 'padded-section-content')}>
                <hgroup>
                  <h1 className="section-heading">
                    Listen free. Anywhere, anytime.
                  </h1>
                  <h2 className="section-description">
                    Download the Live365 app now!
                  </h2>
                </hgroup>

                <div className={classNames('row', 'store-badges')}>
                  <a href="https://itunes.apple.com/us/app/live365-radio-music-talk/id1228431134?mt=8">
                    <img alt="Download on the App Store" src={appStoreBadge} />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.live365&hl=en">
                    <img alt="Get it on Google Play" src={googlePlayBadge} />
                  </a>
                </div>
              </div>
            </Fade>

            <Fade bottom duration={700} fraction={0.5}>
              <img
                src={mobileAppOnDevice}
                alt="Live365 mobile app"
                className={classNames('image-at-bottom-edge', 'desktop-only')}
              />
            </Fade>
          </div>
        </PageSection>
      </Page>
    )
  }
}

export default Home
